import { render, staticRenderFns } from "./courseUpdate.vue?vue&type=template&id=c8e7107c&"
import script from "./courseUpdate.vue?vue&type=script&lang=js&"
export * from "./courseUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports